import { getToken, setToken, removeToken } from '@/utils/auth'
import request from '@/utils/request'

const state = {
  token: getToken(),
  tokenInfo: null,
  userInfo: null,
  roles: [],
  permissions: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_TOKEN_INFO: (state, tokenInfo) => {
    state.tokenInfo = tokenInfo
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },
  CLEAR_USER: (state) => {
    state.token = ''
    state.tokenInfo = null
    state.userInfo = null
    state.roles = []
    state.permissions = []
  }
}

const actions = {
  // 用户登录
  async login({ commit, dispatch }, userInfo) {
    const { username, password } = userInfo
    
    try {
      const response = await request({
        url: '/ums/auth/token',
        method: 'post',
        data: {
          username,
          password
        }
      })
      
      if (response.code === 200) {
        const { token, tokenHead, tokenHeader, expiration } = response.data
        
        // 保存token信息
        const tokenInfo = {
          token,
          tokenHead,
          tokenHeader,
          expiration
        }
        
        commit('SET_TOKEN', token)
        commit('SET_TOKEN_INFO', tokenInfo)
        setToken(token)
        
        // 保存其他token信息到localStorage
        localStorage.setItem('tokenHead', tokenHead)
        localStorage.setItem('tokenHeader', tokenHeader)
        localStorage.setItem('expiration', expiration)
        
        // 登录成功后自动获取用户信息
        try {
          await dispatch('getInfo')
        } catch (error) {
          console.warn('获取用户信息失败:', error)
        }
        
        return Promise.resolve(response)
      } else {
        console.log("aaaaa====response:", response)
        return Promise.reject(new Error(response.message || '登录失败'))
      }
    } catch (error) {
      console.log("aaaaa====error:", error)
      return Promise.reject(error)
    }
  },

  // 获取用户信息
  async getInfo({ commit }) {
    try {
      const response = await request({
        url: '/ums/auth/current',
        method: 'get'
      })
      
      if (response.code === 200) {
        const userInfo = response.data
        
        // 设置默认角色和权限（如果后端没有提供）
        const roles = userInfo.roles || ['user']
        const permissions = userInfo.permissions || ['read']
        
        commit('SET_ROLES', roles)
        commit('SET_PERMISSIONS', permissions)
        commit('SET_USER_INFO', userInfo)
        
        return Promise.resolve(userInfo)
      } else {
        return Promise.reject(new Error(response.message || '获取用户信息失败'))
      }
    } catch (error) {
      return Promise.reject(error)
    }
  },

  // 更新用户信息
  updateProfile({ commit }, profileData) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('SET_USER_INFO', { ...state.userInfo, ...profileData })
        resolve()
      }, 300)
    })
  },

  // 修改密码
  changePassword(_, passwordData) {
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log('密码已更新:', passwordData)
        resolve()
      }, 300)
    })
  },

  // 用户登出
  logout({ commit }) {
    return new Promise((resolve) => {
      commit('CLEAR_USER')
      removeToken()
      resolve()
    })
  },

  // 重置Token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit('CLEAR_USER')
      removeToken()
      // 清除其他token信息
      localStorage.removeItem('tokenHead')
      localStorage.removeItem('tokenHeader')
      localStorage.removeItem('expiration')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
